function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    \n    ", "\n\n    html{\n      ", "\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable no-unused-expressions */
import styledNormalize from 'styled-normalize';
import { createGlobalStyle } from 'styled-components';
import { arrayOf, string } from 'prop-types';
var boxSizing = "/* Box Sizing https://bit.ly/1A91I0J */\n    html {\n      box-sizing: border-box;\n      font-size: 100%;\n    }\n    *, *:before, *:after {\n      box-sizing: inherit;\n    }";
var GlobalStyles = /*#__PURE__*/createGlobalStyle(_templateObject(), styledNormalize, boxSizing, function (_ref) {
  var fonts = _ref.fonts;
  return fonts || null;
});
GlobalStyles.propTypes = {
  fonts: arrayOf(string)
};
GlobalStyles.defaultProps = {
  fonts: null
};
export default GlobalStyles;